export default {
	title: {
		icon: require('@/assets/images/equipment/xxgsp/icon.png'),
        name: '信息公示屏',
	},

	// 表头配置
	tableTh: {
		discNoRepeat: '',

		xh: '型号',
        pmcc: '屏幕尺寸：',
        fbl: '分辨率：',
        sp: '视频：',
        bg: '背光：',
        yp: '音频：',
        znxt: '智能系统：',
        HDMIjk: 'HDMI接口：',
        wl: '网络：',
        USBjk: 'USB接口：',
        gh: ' 功耗：',
	},

	// 表格行数据
	tableTr: [
		{
			discNoRepeat: {
				cover: require('@/assets/images/equipment/xxgsp/pc_01.png'),
                name: '55寸智能液晶显示屏'
			},
            xh: 'VTLED-55-S',
            pmcc: '55英寸;',
            fbl: '4K（3,840 x 2,160）;',
            sp: 'HDR (高动态范围图像);',
            bg: '超高对比度 350流明; ',
            yp: '立体声 2x10w',
            znxt: '安卓系统,8核处理器;',
            HDMIjk: '3个;',
            wl: '有线、WIFI；',
            USBjk: '2个;',
            gh: '平均130W;',
		},
		{
			discNoRepeat: {
				cover: require('@/assets/images/equipment/xxgsp/pc_01.png'),
                name: '65寸智能液晶显示屏',
			},
            xh: 'VTLED-65-S',
            pmcc: '65英寸',
            fbl: '4K（3,840 x 2,160）;',
            sp: 'HDR (高动态范围图像);',
            bg: '超高对比度 350流明; ',
            yp: '立体声 2x10w',
            znxt: '安卓系统,8核处理器;',
            HDMIjk: '3个;',
            wl: '有线、WIFI；',
            USBjk: '2个;',
            gh: '平均150W;',
		},

    ],
    
    part: [
        {
            cover: require('@/assets/images/equipment/xxgsp/pc_03.png'),
            title: '公示内容更丰富',
            disc: '除国家要求规定的公示信息外 还可以视频、图片、文字等形式公示其它信息，内容、形式更丰富'
        },
        {
            cover: require('@/assets/images/equipment/xxgsp/pc_04.png'),
            title: '公示操作更简单',
            disc: '系统自动更新溯源、供应商、明厨亮灶等公示信息 屏幕自动轮播相关信息，无需专人管理、操作。'
        },
    ],
}
